import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 2;

export const migration_1_2:IMigration = {
    from: 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === 1);

        console.log('migration 1->2 designState', designState);

        if( designState.spreadsheets && designState.spreadsheets.workbooks )
            Object.values(designState.spreadsheets.workbooks).forEach((workbookSnapshot:any) =>
            {
                workbookSnapshot.runtime.sheets.forEach((sheetSnapshot:any) =>
                {
                    sheetSnapshot.slotLocationToSlot = {};

                    Object.values(sheetSnapshot.slots).forEach((slotSnapshot:any) =>
                    {
                        sheetSnapshot.slotLocationToSlot[`${slotSnapshot.location.colIndex}_${slotSnapshot.location.rowIndex}`] = slotSnapshot.id;
                    });
                });
            });

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
